import { FluidDate } from '@lmig/fluid-core/lib/structs/types/fluid-date.type';

export function convertToDate(input: FluidDate): Date | null {
  if (typeof input === 'string') {
    const date = new Date(input);
    return isNaN(date.getTime()) ? null : date;
  }

  if (typeof input === 'number') {
    const date = new Date(input);
    return isNaN(date.getTime()) ? null : date;
  }

  if (input instanceof Date) {
    return input;
  }

  return null;
}
